import type { IconProps } from './IconProps';

export const DefinedIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      d="M0.0321835 1.19092H6.08267C10.7908 1.19076 13.2473 1.45704 15.0297 4.40926C15.6114 5.37271 16.2057 6.99009 15.9308 8.72185C15.4454 11.78 13.9931 13.6661 11.2964 14.4827C10.0075 14.873 8.27382 14.8045 6.59761 14.8045H0V12.9057H1.41607V3.05756H0.0321835V1.19092ZM3.63673 3.05756V12.9057H4.98844V3.05756H3.63673ZM7.2091 3.05756V12.9057C9.81374 12.9366 11.6015 12.7169 12.6803 11.2643C13.0454 10.7727 13.3177 10.1399 13.4849 9.46207C14.2336 6.42656 12.6991 3.97653 10.5884 3.31503C9.66518 3.0257 8.41437 3.04909 7.2091 3.05756Z"
      fill="currentColor"
    />
  </svg>
);
